module.exports = __webpack_public_path__ + "static/media/lenen_bank_laag.3eaecbc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/lenen_bank_laag.svg
// module id = 944
// module chunks = 0